import React, { useRef } from "react";
import { useDrop } from "react-dnd";
import { Player } from "../../interfaces/Player.Interface";
import TeamCardPlayerComponent from "./TeamCardPlayer.Component";
import "./PlayerPool.Styles.scss";

interface Props {
  playerPool: Player[];
  players: string[];
  removePlayer: (playerId: string) => void;
}

export default function PlayerPoolComponent(props: Props) {
  const poolRef = useRef(null);
  const { playerPool, players } = props;
  const [, drop] = useDrop({
    accept: "player",
    drop(item) {
      props.removePlayer((item as any).id);
    },
  });

  const renderPlayerPool = () => {
    let pool: JSX.Element[] = [];

    for (const i of playerPool) {
      let canAdd = true;
      for (const j of players) {
        if (i.playerId === j) {
          canAdd = false;
        }
      }
      if (canAdd) {
        pool.push(<TeamCardPlayerComponent key={i.playerId} player={i} />);
      }
    }

    return pool;
  };
  drop(poolRef);
  return (
    <div className="player-pool-container" ref={poolRef}>
      {renderPlayerPool()}
    </div>
  );
}
